export const TABLE_HEAD_TAGS = [
  { id: 'id', label: 'tag.id', alignRight: false },
  { id: 'name', label: 'tag.name', alignRight: false },
  { id: 'description', label: 'tag.description', alignRight: false },
  { id: 'department', label: 'tag.department', alignCenter: true },
  { id: 'createdBy', label: 'tag.createdBy', alignCenter: true },
  { id: 'createdAt', label: 'tag.createdAt', alignCenter: true },
  { id: 'updatedAt', label: 'tag.updatedAt', alignCenter: true },
  { id: 'actions', label: 'tag.actions', sticky: true },
];
